export const DEFAULT_CHECKLESS_MODULE_CONTEXT = {
  title: 'Pay with Covered',
  description:
    "Save your card in advance of your upcoming reservation. You'll be charged automatically at the end of your visit. No more waiting for the check, no more searching your wallet — just enjoy your meal and leave when you're ready.",
  buttonText: 'Enroll'
};

export const baseGoogleCalendarURL = 'https://www.google.com/calendar/render?';
